import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

interface RouteMeta {
  description?: string;
  keywords?: string;
}

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy {
  private static readonly DESCRIPTION_TAG = 'description';
  private static readonly KEYWORDS_TAG = 'keywords';
  private readonly translate = inject(TranslateService);
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title) {
      this.title.setTitle(this.translate.instant(title));
    } else {
      this.title.setTitle(this.translate.instant('page.eskhata-business'));
    }

    const leafRoute = this.getLeafRoute(snapshot.root);
    const routeMeta = leafRoute.data?.['meta'] as RouteMeta | undefined;
    this.updateMetaTags(routeMeta);
  }

  private updateMetaTags(metaData: RouteMeta | undefined): void {
    if (!metaData) return;

    if (metaData.description) {
      this.meta.updateTag({
        name: CustomPageTitleStrategy.DESCRIPTION_TAG,
        content: this.translate.instant(metaData.description),
      });
    }
    if (metaData.keywords) {
      this.meta.updateTag({
        name: CustomPageTitleStrategy.KEYWORDS_TAG,
        content: this.translate.instant(metaData.description),
      });
    }
  }

  private getLeafRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }
}
